export default function Brand({ compact = false }) {
  return <div className={`brand ${compact ? 'brand-compact' : ''}`}>
    <svg viewBox="0 0 34 34" width="33" height="33" aria-hidden="true">
      <path d="M8 3h10v7H8a3 3 0 0 0-3 3v6H0v-8a8 8 0 0 1 8-8Z" fill="currentColor" />
      <path d="M26 31H16v-7h10a3 3 0 0 0 3-3v-6h5v8a8 8 0 0 1-8 8Z" fill="currentColor" />
      <path d="m8 22 14-14 5 5-14 14Z" fill="currentColor" />
    </svg>
    {!compact && <span>linkflow<span className="brand-period">.</span></span>}
  </div>;
}
